import { render, staticRenderFns } from "./Microscope.vue?vue&type=template&id=528e396a"
import script from "./Microscope.vue?vue&type=script&lang=js"
export * from "./Microscope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports